import React, { useEffect } from "react";
import Punch from "../myattendance/Punch";
import PunchDetails from "../myattendance/PunchDetails";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function MyAttendance() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "YellowCalf | My Attendance ";
  }, []);
  return (
    <>
      {/* Container-fluid starts */}
      <div className="row my-attendance">
        <div className="col-md-12 text-end app-le">
          <Link to="/EmpLeaves" className="btn-apply-leave">
            {t("Apply Leave")}
          </Link>
        </div>
        <div className="col-md-12">
          <div className="card profile-greeting">
            <div className="confetti">
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
              <div className="confetti-piece"></div>
            </div>
            <div className="card-body">
              <div className="row edsys-check-in">
                <Punch />
                <PunchDetails />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Container-fluid Ends  */}
    </>
  );
}

export default MyAttendance;
